import React, { memo, useState } from 'react';
import { createPortal } from 'react-dom';
import useIsMobile from './useIsMobile';

function NoCutBlock({
  title,
  piecesStr, metersStr, tonsStr,
  onPiecesChange, onMetersChange, onTonsChange,
  onMinusPiece, onPlusPiece,
  onMinusMeter, onPlusMeter,
  onMinusTonn, onPlusTonn,
  onBlurPieces, onMetersBlur, onBlurTons,
  onStandardCut,
  children,
  visible = true,
  showActionButtons = true,
  distributedCount = 0,
  totalSheets = 0
}) {
  const isMobile = useIsMobile(480);
  const [showLengthWarning, setShowLengthWarning] = useState(false);

  const handleCutClick = () => {
    const meters = parseFloat(String(metersStr || '0').replace(',', '.')) || 0;
    if (meters < 0.50) {
      setShowLengthWarning(true);
      return;
    }
    if (onStandardCut) onStandardCut();
  };

  const S = {
    container: {
      border: '1px solid #BCBCBC',
      borderRadius: '10px',
      padding: isMobile ? '16px' : '24px',
      background: '#fff',
      fontFamily: '"Commissioner", sans-serif',
      marginBottom: '16px',
      boxSizing: 'border-box',
    },
    title: {
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: '500',
      color: 'black',
      margin: '0 0 24px 0',
      lineHeight: 'normal',
      wordWrap: 'break-word'
    },
    controlsRow: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '16px',
      alignItems: isMobile ? 'stretch' : 'flex-start',
    },
    inputCol: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      flexShrink: 0,
    },
    label: {
      fontSize: '12px',
      fontWeight: '400',
      color: 'black',
      margin: 0,
      lineHeight: 'normal',
      textAlign: 'center'
    },
    inputGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: '#EDEDED',
      borderRadius: '10px',
      padding: '4px',
      width: '200px',
      height: '44px',
      boxSizing: 'border-box',
    },
    pmBtn: {
      width: '48px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      padding: 0,
    },
    inputField: {
      width: '80px',
      textAlign: 'center',
      border: 'none',
      background: 'transparent',
      fontSize: '24px',
      fontWeight: '600',
      color: 'black',
      padding: 0,
      margin: 0,
      outline: 'none',
      fontFamily: 'inherit',
      lineHeight: 'normal'
    },
    subtext: {
      fontSize: '12px',
      fontWeight: '400',
      color: 'black',
      margin: 0,
      textAlign: 'center',
      lineHeight: 'normal'
    },
    actionWrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: isMobile ? 0 : '22px'
    },
    actionBtn: {
      width: '100%',
      height: '44px',
      backgroundColor: '#157BD7',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.2s',
      fontFamily: 'inherit',
      lineHeight: 'normal',
      textTransform: 'uppercase'
    }
  };

  return (
    <div style={visible ? S.container : { display: 'none' }}>
      <style>{`
        .counter-input-no-spin::-webkit-inner-spin-button,
        .counter-input-no-spin::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
          margin: 0 !important;
        }
        .counter-input-no-spin {
          -moz-appearance: textfield !important;
        }
      `}</style>
      {visible && (
        isMobile ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px', flexShrink: 0 }}>
                <div style={{ fontSize: '12px', fontWeight: '400', color: 'black', margin: 0, lineHeight: 'normal' }}>Количество (шт):</div>
                <div style={{ ...S.inputGroup, width: '150px' }}>
                  <button type="button" style={{ ...S.pmBtn, width: '36px' }} onClick={onMinusPiece}>
                    <svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="0.5" width="10.08" height="3.55" fill="black" />
                    </svg>
                  </button>
                  <input
                    type="number"
                    className="counter-input-no-spin"
                    style={{ ...S.inputField, width: '60px', fontSize: '20px' }}
                    value={piecesStr !== undefined && piecesStr !== null ? (piecesStr === '0.00' ? '0' : piecesStr) : '0'}
                    onChange={e => onPiecesChange(e.target.value)}
                    onBlur={e => {
                      let v = parseInt(e.target.value, 10);
                      if (isNaN(v) || v < 0) v = 0;
                      onPiecesChange(v);
                      if (onBlurPieces) onBlurPieces(e);
                    }}
                    min="0"
                    onClick={e => e.target.select()}
                  />
                  <button type="button" style={{ ...S.pmBtn, width: '36px' }} onClick={onPlusPiece}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5.225" y="0" width="3.55" height="14" fill="black" />
                      <rect x="0" y="5.225" width="14" height="3.55" fill="black" />
                    </svg>
                  </button>
                </div>
                <div style={{ fontSize: '12px', fontWeight: '400', color: 'black', margin: 0, lineHeight: 'normal' }}>
                  {(() => {
                    const m = parseFloat(metersStr || 0);
                    const tons = parseFloat(tonsStr || 0);
                    const tonsFormatted = parseFloat(tons.toFixed(4)).toString().replace('.', ',');
                    return `${m.toFixed(2)} м / ${tonsFormatted} т`;
                  })()}
                </div>
              </div>
              <h3 style={{ fontSize: '18px', fontWeight: '500', color: 'black', margin: 0, lineHeight: '1.2', wordWrap: 'break-word', textAlign: 'right', flex: 1 }}>
                {title || 'Лист 0,4 мм оцинк 1,25х2,5м'}
              </h3>
            </div>
            
            {distributedCount > 0 && (
              <div style={{
                height: '44px',
                paddingLeft: '16px',
                paddingRight: '16px',
                borderRadius: '10px',
                outline: '1px solid #6F7B91',
                outlineOffset: '-1px',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '13px',
                boxSizing: 'border-box',
                marginBottom: '16px',
                width: '100%'
              }}>
                <div style={{
                  width: '100%',
                  textAlign: 'center',
                  color: '#6F7B91',
                  fontSize: '12px',
                  fontFamily: 'Commissioner',
                  fontWeight: '500',
                  wordWrap: 'break-word'
                }}>
                  Распределено:&nbsp;{distributedCount}&nbsp;из&nbsp;{totalSheets}.&nbsp;&nbsp;(Осталось:&nbsp;{Math.max(0, totalSheets - distributedCount)})
                </div>
              </div>
            )}

            {showActionButtons && (
              <div style={{ width: '100%' }}>
                <button
                  type="button"
                  style={{ ...S.actionBtn, width: '100%' }}
                  onClick={handleCutClick}
                >
                  ДОБАВИТЬ РУБКУ
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <h3 style={S.title}>{title || 'Лист 0,4 мм оцинк 1,25х2,5м'}</h3>

            <div style={S.controlsRow}>
              <div style={S.inputCol}>
                <div style={S.label}>Количество (шт):</div>
                <div style={S.inputGroup}>
                  <button type="button" style={S.pmBtn} onClick={onMinusPiece}>
                    <svg width="11" height="4" viewBox="0 0 11 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="0.5" width="10.08" height="3.55" fill="black" />
                    </svg>
                  </button>
                  <input
                    type="number"
                    className="counter-input-no-spin"
                    style={S.inputField}
                    value={piecesStr !== undefined && piecesStr !== null ? (piecesStr === '0.00' ? '0' : piecesStr) : '0'}
                    onChange={e => onPiecesChange(e.target.value)}
                    onBlur={e => {
                      let v = parseInt(e.target.value, 10);
                      if (isNaN(v) || v < 0) v = 0;
                      onPiecesChange(v);
                      if (onBlurPieces) onBlurPieces(e);
                    }}
                    min="0"
                    onClick={e => e.target.select()}
                  />
                  <button type="button" style={S.pmBtn} onClick={onPlusPiece}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5.225" y="0" width="3.55" height="14" fill="black" />
                      <rect x="0" y="5.225" width="14" height="3.55" fill="black" />
                    </svg>
                  </button>
                </div>
                <div style={S.subtext}>
                  {(() => {
                    const m = parseFloat(metersStr || 0);
                    const tons = parseFloat(tonsStr || 0);
                    const tonsFormatted = parseFloat(tons.toFixed(4)).toString().replace('.', ',');
                    return `${m.toFixed(2)} м / ${tonsFormatted} т`;
                  })()}
                </div>
              </div>

              {distributedCount > 0 && (
                <div style={{
                  height: '44px',
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  borderRadius: '10px',
                  outline: '1px solid #6F7B91',
                  outlineOffset: '-1px',
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '13px',
                  boxSizing: 'border-box',
                  marginTop: '22px'
                }}>
                  <div style={{
                    width: '100%',
                    textAlign: 'center',
                    color: '#6F7B91',
                    fontSize: '12px',
                    fontFamily: 'Commissioner',
                    fontWeight: '500',
                    wordWrap: 'break-word'
                  }}>
                    Распределено:&nbsp;{distributedCount}&nbsp;из&nbsp;{totalSheets}.&nbsp;&nbsp;(Осталось распределить:&nbsp;{Math.max(0, totalSheets - distributedCount)})
                  </div>
                </div>
              )}

              {showActionButtons && (
                <div style={S.actionWrapper}>
                  <button
                    type="button"
                    style={S.actionBtn}
                    onClick={handleCutClick}
                  >
                    ДОБАВИТЬ РУБКУ
                  </button>
                </div>
              )}
            </div>
          </>
        )
      )}

      {showLengthWarning && createPortal(
        <div
          onClick={() => setShowLengthWarning(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.35)',
            backdropFilter: 'blur(4px)',
            animation: 'fadeIn .2s ease',
          }}
        >
          <style>{`
            @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
            @keyframes slideUp { from { transform: translateY(24px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
          `}</style>
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: '16px',
              padding: isMobile ? '28px 20px' : '36px 40px',
              maxWidth: '380px',
              width: '90%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
              textAlign: 'center',
              fontFamily: '"Commissioner", sans-serif',
              animation: 'slideUp .3s ease',
            }}
          >
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #FFF3E0, #FFE0B2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#E65100" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div style={{ fontSize: '18px', fontWeight: 700, color: '#1D1D1F', marginBottom: '8px', lineHeight: '1.3' }}>
              Укажите длину
            </div>
            <div style={{ fontSize: '14px', fontWeight: 400, color: '#6B7280', marginBottom: '24px', lineHeight: '1.5' }}>
              Для добавления рубки необходимо указать желаемую длину не менее <b style={{ color: '#1D1D1F' }}>0,50 м</b> в поле «Длина»
            </div>
            <button
              type="button"
              onClick={() => setShowLengthWarning(false)}
              style={{
                width: '100%',
                height: '44px',
                background: '#157BD7',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit',
                transition: 'opacity .2s',
              }}
            >
              Понятно
            </button>
          </div>
        </div>,
        document.body
      )}

      {children}
    </div>
  );
}

export default memo(NoCutBlock);